/* eslint-disable camelcase */
import * as Case from './Case.js'

// Exporting both member functions and default module for backward compat (for now)
export * from './Case.js'

// Source: http://stackoverflow.com/questions/7225407/convert-camelcasetext-to-camel-case-text
export function camelCaseToTitleCase( in_camelCaseString, capitalizeAllOpt ) {  
  const result = in_camelCaseString
    .replace( /([a-z])([A-Z][a-z])/g, '$1 $2' )
    .replace( /[_-]/g, ' ' )
    .replace( /([A-Z][a-z])([A-Z])/g, '$1 $2' )
    .replace( /([a-z])([A-Z]+[a-z])/g, '$1 $2' )
    .replace( /([A-Z]+)([A-Z][a-z][a-z])/g, '$1 $2' )
    .replace( /([a-z]+)([A-Z0-9]+)/g, '$1 $2' )
    .replace( /([A-Z]+)([A-Z][a-rt-z][a-z]*)/g, '$1 $2' )
    .replace( /([0-9])([A-Z][a-z]+)/g, '$1 $2' )
    .replace( /([A-Z]+)([0-9]+)/g, '$1 $2' )
    .replace( /([0-9]+)([A-Z]+)/g, '$1 $2' )
    .trim()

  if ( capitalizeAllOpt === true ) {
    return capitalizeAll( result )
  }
  // capitalize the first letter
  return capitalize( result )
}

export function capitalize( str ) {
  return str == null || str.length === 0 ? str : str.charAt( 0 ).toUpperCase() + str.slice( 1 )
}

export function capitalizeAll( str ) {
  const arr = str.split( ' ' )
  for ( let n = 0; n < arr.length; n++ ) {
    arr[n] = capitalize( arr[n] )
  }
  return arr.join( ' ' )
}

export function escapeRegExp( str ) {
  // eslint-disable-next-line no-useless-escape
  return str.replace( /([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1' )
}

export function replaceAll( str, find, replace ) {
  // eslint-disable-next-line security/detect-non-literal-regexp
  return str.replace( new RegExp( find, 'g' ), replace )
}

export function isEmpty( str ) {
  return str == null || ( typeof str === 'string' && str.trim().length === 0 )
}

// Will return null if str is not a string or if
// trimmed, it is equal to ''. Otherwise this will
// return the trimmed value of str
/**
 * If str is a string, it will returned the trimmed version of the string
 * or null, if the trimmed version is the empty string. If str is not a
 * string, this will return either null (by default) or str if 
 * returnNullIfNotString === false. This will return null if str is undefined.
 **/
export function nullOrTrim( str, returnNullIfNotString = true ) {
  if ( str == null ) {
    return null
  }
  if ( typeof str === 'string' ) {
    const v = str.trim()
    return v.length === 0 ? null : v
  }
  return returnNullIfNotString === false ? str : null
}

// Original source:
// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
/**
 * Returns a integer hashcode for the string. 
 * @param {string} str the string to create a hashCode for
 * @param {boolean} positive if true, the int will be made positive. (false is default)
 **/
export function hashCode( str, positive = false ) {
  let hash = 0
  if ( str == null || str.length === 0 ) {
    return hash
  }
  for ( let i = 0; i < str.length; i++ ) {
    const chr = str.charCodeAt( i )
    hash = ( ( hash << 5 ) - hash ) + chr
    hash |= 0 // Convert to 32bit integer
  }
  return positive === true ? Math.abs( hash ) : hash // make it positive
}

export default {
  ...Case,
  camelCaseToTitleCase,
  capitalize,
  capitalizeAll,
  escapeRegExp,
  replaceAll,
  isEmpty,
  nullOrTrim,
  hashCode
}
